import anime from 'animejs';
import hotkeys from 'hotkeys-js';
/**
 *
 *
 * @export
 * @class Sites
 */
export class Sites {
  private static _instance: Sites;
  private _rootElement: HTMLElement = document.querySelector('.ow-sites');
  private _elements: Array<HTMLElement> = Array.from(this._rootElement.querySelectorAll('li'));
  private _closeButton: HTMLButtonElement = this._rootElement.querySelector('.modal__close');

  /**
   *Creates an instance of Sites.
   * @memberof Sites
   */
  constructor() {
    this.events();
    if (Sites._instance) {
      return this;
    } else {
      Sites._instance = this;
    }
  }

  /**
   *
   *
   * @memberof Sites
   */
  public open(): void {
    this._rootElement.classList.add('ow-sites--show');
    this._closeButton.classList.add('modal__close--show');
    for (let i = 0; this._elements.length > i; i++) {
      setTimeout(() => {
        this._elements[i].classList.add('show');
      }, i * 300);
    }
    document.body.style.overflow = 'hidden';
  }

  /**
   *
   *
   * @private
   * @memberof Sites
   */
  private close(): void {
    document.body.style.overflow = '';
    this._rootElement.classList.remove('ow-sites--show');
    this._closeButton.classList.remove('modal__close--show');
  }

  /**
   *
   *
   * @private
   * @memberof Sites
   */
  private events(): void {
    this._elements.forEach(el => {
      const img: any = el.querySelector('img');
      if (img !== null) {
        let animation: anime = null;
        el.addEventListener('mouseenter', () => {
          if (animation === null) {
            const height = -(img.height - img.parentElement.parentElement.offsetHeight);
            animation = anime({
              targets: img,
              translateY: [0, height],
              easing: 'linear',
              duration: height * -6,
              loop: true,
              direction: 'alternate'
            });
          } else {
            animation.play();
          }
        });
        el.addEventListener('mouseleave', () => {
          animation.pause();
        });
      }
    });
    this._closeButton.addEventListener('click', () => this.close());
    hotkeys('esc', () => {
      this.close();
    });
  }
}
